export default function BusinessBadge({
  business,
  showName = true,
  imageHeight = 20,
  imageWidth = 56,
  imageStyle,
  textStyle,
  style,
}) {
  if (business?.logoURL || business?.name) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          minWidth: 0,
          ...style,
        }}
      >
        {business?.logoURL && (
          <div
            style={{
              height: imageHeight,
              width: imageWidth,
              minWidth: imageWidth,
              borderRadius: 4,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              alt={business?.name || "Business logo"}
              src={business.logoURL}
              style={{
                width: "100%",
                objectFit: "cover",
                objectPosition: "center",
                ...imageStyle,
              }}
            />
          </div>
        )}
        {showName && business?.name && (
          <span
            style={{
              color: "#143C8A",
              fontWeight: 600,
              whiteSpace: "nowrap",
              ...textStyle,
            }}
          >
            {business.name}
          </span>
        )}
      </div>
    );
  }

  return null;
}
